"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  userAndPermission: {
    shoreOrVessel: 'Shore or Vessel',
    resetSuccess: 'Reset Success',
    resetAllUsersBlock: 'Reset All User\'s Blocks',
    resetSelectedUserBlock: 'Reset Selected User\'s Blocks',
    chooseBlock: 'Choose Block',
    userPermission: 'User&Permission',
    accountMaintenance: 'Account Manage',
    userCode: 'Account Code',
    loginName: 'Login Name',
    personMsg: 'Personal Message',
    organization: 'Organisation',
    roleName: 'Part-time Role',
    navigationMenu: 'Navigation Menu',
    pleaseSelectOrg: 'Please Select Organization...',
    pleaseEnter: 'Please Enter Content',
    pleaseSelect: 'Please Select',
    pleaseSelectDate: 'Please Select a Date',
    selectDate: 'Select a Date',
    responsibleShip: 'Responsible Ship',
    nameCn: ' Name(CN)',
    operId: 'Log ID',
    logTitle: 'Operation Module',
    businessType: 'Business Type',
    businessTypes: 'Business Type Array',
    method: 'Request Method',
    requestMethod: 'Request Type',
    operatorType: 'Operation Category',
    operName: 'Operator',
    deptName: 'Department Name',
    operUrl: 'Request URL',
    operIp: 'Operation IP',
    operLocation: 'Operation Address',
    operParam: 'Request Parameter',
    jsonResult: 'Return Parameter',
    status: 'Operating Status',
    errorMsg: 'Wrong Information',
    operTime: 'Operating Time',
    nameEn: 'Name(EN)',
    jobNumber: 'Job Number',
    leaderUserName: 'Report Object',
    defaultRoleName: 'DefaultRole',
    manageWorkType: 'Management',
    reservedStr1: 'Common Role',
    reservedStr2: 'Reservedstr2',
    reservedStr3: 'Reservedstr3',
    reservedStr4: 'Reservedstr4',
    reservedStr5: 'Reservedstr5',
    vesselCode: 'Vessel Code',
    commonRole: 'Common Role',
    validFlag: 'Is Cancellation',
    valid: 'Valid',
    invalid: 'Invalid',
    invalidDate: 'Cancels the Date',
    additional: 'Additional Post',
    isJobFlagShow: 'Role Category',
    companyName: 'Part-time Company',
    certNumber: 'ID number',
    jobRole: 'Job Role',
    postRole: 'Non Job Role',
    accountCode: 'Account Code',
    userNameCn: 'Account Name(CN)',
    userNameEn: 'Account Name(EN)',
    defaultOfficeName: 'Default Office',
    defaultRole: 'Default Role',
    sex: 'Gender',
    logoutStatus: 'Logged Out',
    officePhone: 'Office Phone',
    email: 'Email Address',
    index: 'No.',
    deptManager: 'Department Manager',
    validStatus: 'Logged Out',
    operation: 'Operation',
    documentType: 'Certificate Type',
    phoneNumber: 'Phone',
    fax: 'Fax',
    wechat: 'Wechat',
    qqNumber: 'QQ',
    nativePlace: 'Native Place',
    maritalStatus: 'Marital Status',
    entryTime: 'Time of Entry',
    graduationYear: 'Graduation',
    remark: 'Remark',
    creator: 'Creator',
    createTime: 'Creation Time',
    updateUser: 'Update',
    seqNo: 'seqNo',
    isHsqeFlag: 'Hsqe',
    updateDate: 'UpdateTime',
    addAccount: 'Add Account',
    man: 'Male',
    woman: 'Female',
    false: 'No',
    true: 'Yes',
    certTypeEmpty: 'The id type cannot be empty',
    certNumberEmpty: 'The id number cannot be empty',
    notCancelled: 'Not Cancelled',
    cancelled: 'Cancelled',
    married: 'Married',
    unmarried: 'Unmarried',
    mainlandIdCard: 'ID Crad',
    HKIdCard: 'HK ID Card',
    Fujian: 'Fujian',
    Beijing: 'Beijing',
    orgCode: 'OranganizeCode',
    orgName: 'OranganizeName',
    parentOrgCode: 'Parent OranganizeCode',
    parentOrgName: 'Parent OranganizeName',
    orgType: 'OranganizeType',
    officeCode: 'Company Code',
    officeName: 'Company Name',
    departmentCode: 'dept Code',
    departmentName: 'dept Name',
    roleCode: 'Role Code',
    characterName: 'Role Name(CN)',
    characterNameEn: 'Role Name(EN)',
    parentRoleCode: 'Parent Rolecode',
    parentRoleName: 'Parent Rolename',
    employeeNo: 'Employee No',
    inputJobNumber: 'Please enter the Employee No',
    between50: 'The length ranges from 1 to 50 characters',
    inputNameCn: 'Please enter your Chinese name',
    inputNameEn: 'Please enter your Egnlish name',
    between100: 'The length ranges from 1 to 100 characters',
    between500: 'The length ranges from 1 to 500 characters',
    selectOrg: 'Please select your organization',
    selectLoginID: 'Please enter your login account',
    selectSex: 'Please choose gender',
    selectRole: 'Please select roles',
    selectHolidayCrew: 'Please select the crew on vacation',
    addUserMsg: 'Add User Message',
    editUserMsg: 'Edit User Message',
    group: 'Group',
    company: 'Comapany',
    companyRoleName: 'Concurrent Positions in the Company',
    dept: 'Dept',
    errMsg: 'Data request failed. Please try again later',
    selectOrgUser: 'Please select the people you want to move your organization',
    selectTransferorg: 'Please select the organization you want to migrate',
    selectOrganizationNo: 'Please select the account for which you want to migrate the organization',
    transferSuccess: 'Successful migration',
    selectDeleteNo: 'Please select the account you want to delete',
    confirm: 'Confirm',
    cancel: 'Cancel',
    addSuccess: 'New success',
    editSuccess: 'Edit success',
    selectDelUser: 'Select the person to delete',
    delRecord: 'Are you sure to delete the record',
    selsectStartTime: 'Please select a start time',
    addLessAccount: 'Please add at least one record',
    delSuccess: 'successfully delete',
    changeTimeSuccessfully: 'Change the time successfully',
    selsectLogout: 'Please select the record where you want to change the time',
    cancelCancellationUser: 'Please select the person to cancel the logout',
    cancelCancellationSuccess: 'Cancel logout successfully',
    cancellationUser: 'Please select the person to cancel',
    cancellationNo: 'Please select the account you want to cancel',
    selectcancellationNo: 'Please select the account you want to cancel',
    cancellationSuccess: 'Cancellation of success',
    selectMostAccount: 'Please select at most one account',
    hints: 'Please select a record',
    selectMostShip: 'Please select to check at least one ship',
    selectDeleteShip: 'Please select the ship to delete',
    accountNumber: 'Account Number[',
    passwordResetSuccessfully: ']Reset Password Successfully, The Initial Password Is【',
    message1: 'Role categories and concurrent roles cannot be empty',
    message2: 'Concurrent post in the company cannot be vacant',
    message3: 'The organization cannot be empty',
    saveSuccessfully: 'save successfully',
    message4: 'Please save your account number first',
    message5: 'Select the record to delete',
    message6: 'Are you sure to delete the record',
    hint: 'Tip',
    resetPassword: 'Reset Password',
    startTime: 'Start Time',
    endTime: 'End Time',
    changeTime: 'Change Time',
    vesselTeamName: 'Name of the Fleet',
    vesselName: 'Name of the Ship',
    beginDate: 'Begin Time',
    boatTrain: 'Boat Train',
    shipping: 'Vessel',
    management: 'Management',
    refresh: 'Refresh',
    accordingCancellation: 'show cancellation',
    fastSearch: 'Fast Search',
    all: 'All',
    sort: 'Rort',
    order: 'Sequence',
    systemManagement: 'System Manage',
    configurationMenu: 'Menu Config',
    addNode: 'Add Main Node',
    shrink: 'Shrink',
    unfold: 'Unfold',
    detailedInformation: 'Detailed Information',
    type: 'Type',
    routingAddress: 'Routing Address',
    redirect: 'Redirect Address',
    eg: 'Eg,/',
    egDashboard: 'Eg, / Dashboard',
    componentAddress: 'Page Component Address',
    routName: 'Name of the Routing',
    suchIndex: 'such as index',
    title: 'Title',
    titleCn: 'Chinese Title',
    titleEn: 'English Title',
    selectTitle: 'Please input the title',
    selectCnTitle: 'Please input the title of Chinese',
    selectEnTitle: 'Please input the title of English',
    icon: 'Icon',
    pathSeq: 'Order',
    suchDashboard: 'such as dashboard',
    selectOrder: 'Please enter the order',
    alwaysShow: 'Show the Root Route',
    hidden: 'Hide Item Menu',
    activeMenu: 'Highlight Menu Routing',
    dashboardOptional: 'For example, / Dashboard, select',
    noCache: 'Do not Cache',
    applyCompanys: 'Apply Companys',
    selectCompany: 'Please Select Company',
    btnTitle: 'Button Title',
    btnPath: 'Button Path',
    btnName: 'Button Name',
    component: 'Component',
    menuConfigurationInstructions: 'Menu configuration Instructions',
    pathTypeInstructions: "Optional type (MENU: MENU, displayable page;Under the specific menu, select this configurable parameter and it will change accordingly;SYSTEM: the highest level, usually not selected when configured;MODULE: A MODULE, usually navigates at the top, with components configured as 'layout';GROUP: GROUP, secondary route, including MENU, need to configure 'Router-View' in the component, to display the submenu",
    pathInstructions: "If you fill in the absolute address, the subroute should contain a parent, such as '/manage ', the submenu '/ Manage /user', the three-level route '/ Manage /user/list', and so on",
    redirectInstructions: 'Redirect the address to redirect the new address when the route is accessed',
    componentInstructions: "Component path, the default is view folder path, configuration ellipsis ('the view'), such as'/manage/userAndPermission/featureMange '",
    strongInstructions: "Notice that the front-end code adds component information to 'utils/ Page.js' before making a choice",
    nameInstructions: "For example, 'featureManage' with uppercase initials",
    iconInstructions: 'Icon provided according to Ali Icon',
    titleInstructions: 'Select the title, related to internationalization i18N',
    titleStrongInstructions: 'Under the Lang folder, configure the Router title',
    edit: 'Add',
    update: 'Update',
    menu: 'Menu',
    button: 'Button',
    system: 'System',
    module: 'Module',
    groups: 'Group',
    selectType: 'Please select type',
    enterRouting: 'Please enter the route',
    componentsNotEmpty: 'Component cannot be empty',
    routerNotEmpty: 'The route name cannot be empty',
    titleNotEmpty: 'Headings cannot be empty',
    orderNotEmpty: 'The order cannot be empty',
    selectDeleteMenu: 'Please select the menu to delete',
    isDeleteRecord: 'The unconfigured person takes care to verify that the record is deleted',
    functionalAuthority: 'Functional Authority',
    urlTitleShow: 'Permissions on the Title',
    url: 'Permission to Address',
    urlType: 'Permission Types',
    urlSeq: 'Address the Order',
    boName: 'Business Object Name',
    methodName: 'Method Name',
    tableName: 'Table Name',
    columnName: 'Field Name',
    refreshAllCache: 'Refresh All Cache',
    refreshSuccess: 'Refresh Success',
    desc: 'Desc',
    operatorValue: 'Operator',
    generateScript: 'Generate the Script',
    conditionValue: 'Condition',
    urlParamList: 'Parameter List',
    rolePermission: 'Role Permission',
    personnel: 'Personnel',
    parentResourceName: 'Higher Authority',
    urlLevel: 'Address Level',
    menuNotEmpty: 'The MENU table name cannot be empty',
    newPermissions: 'Permissions Add',
    permissionEditing: 'Permissions Edit',
    urlTitle: 'Title',
    location: 'Location',
    enterPermissionTitle: 'Please enter the permission title',
    enterPermissionAddress: 'Please enter the permission address',
    configurationManagement: 'Configuration Management',
    conditionSql: 'Condition SQL',
    crudType: 'Operation',
    pleaseInput: 'Please input...',
    explain: 'Explain',
    loginAccountName: 'Login AccountName',
    loginAccountBelongs: 'Login AccountBelongs',
    selectOrganizationAccount: 'Please select the Organization',
    selectTable: 'Please select the table name',
    selectRoleAccount: 'Please select the role',
    selectChildNode: 'Please select the child node',
    conditionSqlNotNull: 'condition sql not null',
    pleaseSaveFirst: 'Data has not been saved, please save first',
    SelectDataDelete: 'Select the data to delete',
    roleMaintaining: 'Role Maintain',
    parentRole: 'Superior Role',
    officeChiefFlag: 'Department Head',
    VirtualRole: 'Virtual Role',
    VirtualRoleYes: 'Yes',
    VirtualRoleNo: 'No',
    effDate: 'Valid From',
    expDate: 'Expiration Date',
    loseEfficacy: 'Lose Efficacy',
    errorTimes: 'Error Times',
    operatingAuthorization: 'Operating Authorization',
    authorizationsPrivileges: 'Authorizations and Privileges',
    bankAccountNo: 'Account',
    temporalComparison: 'The end time cannot be less than the beginning time',
    selectOrganization: 'Please select a superior organization',
    selectCategory: 'Please select the role category',
    enterRoleName: 'Please enter the role name',
    between200: 'The length is between 1 and 200 characters',
    enterEnglishName: 'Please enter the English name of the character',
    maintainedCurrentPage: 'The organization node cannot be maintained on the current page',
    companiesDepartmentsNotEmpty: 'Companies and departments should not be empty',
    updateSuccessfully: 'update successfully',
    selectAccountNo: 'Please select the account number',
    deleteAccountNo: 'Please select the account information to delete',
    isFlagAllSelected: 'Permission Role',
    defaultRoleFlag: 'IsdefaultRole ',
    defaultRoleFlagMsg1: 'The role of the current account is the default role and cannot be deleted!',
    defaultRoleFlagMsg2: 'In the selected account, the role with the account is the default role, please check and delete it!',
    authorizedApproval: 'Authorized Approval',
    authorizer: 'Authorizer',
    beiAuthorizer: 'Authorized Person',
    authorizationTime: 'Authorization Start Time',
    authorizationEndTime: 'Authorization End Time',
    authorizationTerminationTime: 'Termination Time',
    quantityProcessed: 'Quantity Processed',
    addAuthorizeMsg: 'Add Authorize Msg',
    editAuthorizeMsg: 'Edit Authorize Msg',
    authorizerCompany: '授权人公司',
    authorizationRole: '授权角色',
    authorizationType: '授权类型',
    messageNotification: '消息提醒',
    emailAlert: '邮件提醒',
    save: '保存',
    selectResetMsg: 'Please select reset user account'
  }
};